<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show="boo_modal"
    :close-on-backdrop="false"
    :centered="true"
    :title="title"
    :size="'xl'"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
    :fullScreen="true"
  >
    <div class="row d-flex">
      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 table-responsive"
      >
        <div class="form-group">
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Buscar por Molecula, Presentación, Marca o Lote"
            v-model="search"
          />
        </div>
      </div>
      <div
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 table-responsive mt-2"
      >
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Otros lotes</th>
              <th>Servicio</th>
              <th>Despacho</th>
              <th>Hora</th>
              <th>Molecula</th>
              <th>Presentación</th>
              <th>Dosis</th>
              <th>Marca</th>
              <th>Lote</th>
              <th>Fec. Venc.</th>
              <th>Cnt. despachada</th>
              <th>Cnt. devuelta</th>
              <th>Devolucion</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in cpData" :key="index">
              <td class="text-center">
                <button
                  v-if="item.type == 1"
                  class="btn btn-sm btn-info text-white"
                  @click="mtdViewOtherLote(item)"
                >
                  <i class="fas fa-eye"></i>
                </button>
              </td>
              <td>{{ item.incomen }}</td>
              <td>{{ item.serie }}</td>
              <td>{{ item.fecha_hora }}</td>
              <td>{{ item.molecule }}</td>
              <td>{{ item.presentation }}</td>
              <td>{{ item.dosis }}</td>
              <td>{{ item.brand }}</td>
              <td>{{ item.lote }}</td>
              <td>{{ item.date }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.devolution_bd == null ? 0 : item.devolution_bd }}</td>
              <td>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  :disabled="
                    item.type == 1 ? item.quantity == item.devolution_bd : false
                  "
                  placeholder="Digite cantidad a devolver"
                  v-model="item.devolution"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <template #footer>
      <button class="btn btn-success btn-sm" @click="registrarDev">
        <i class="fas fa-save" />&nbsp; GUARDAR
      </button>
    </template>
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import { elements } from "chart.js";
import { mapActions } from "vuex";

export default {
  name: "c-devoluciones",
  components: {
    SweetAlert,
    CModal,
  },
  data() {
    return {
      swal: null,
      data: [],
      search: "",

    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
    recipe: Array,
  },
  created() {},
  computed: {
    cpData(){
      if(this.search.trim().length == 0){
        return this.data;
      } else {
        return this.data.filter(item => {
          const searchLower = this.search.toLowerCase();
          return (
            (item.molecule && item.molecule.toLowerCase().includes(searchLower)) ||
            (item.presentation && item.presentation.toLowerCase().includes(searchLower)) ||
            (item.brand && item.brand.toLowerCase().includes(searchLower)) ||
            (item.lote && item.lote.toLowerCase().includes(searchLower))
          );
        });
      }
    }
  },
  watch: {
    recipe: {
      immediate: true,
      handler(newVal) {
        this.data = [];
        if (newVal.length > 0) {
          newVal.forEach(det => {
            console.log(det);
            Object.values(det.recipe_details).forEach((element) => {
              element.dispatch.forEach((item) => {
                this.data.push({
                  type: 1,
                  patient_id: det.patient_id,
                  serie:
                    item.dispatch_pharmacy.serie +
                    "-" +
                    item.dispatch_pharmacy.number,
                  dispatch_pharmacy_id: item.dispatch_pharmacy.id,
                  molecule: element.dispatch[0].product_detail.commercial,
                  presentation: element.presentation,
                  lote: item.dispatch_detail.lote,
                  quantity: item.quantity,
                  devolution: "",
                  product_detail_id: item.product_detail_id,
                  dispatch_detail_id: item.dispatch_detail_id,
                  id: item.id,
                  brand: item.product_detail.brand?.name,
                  devolution_bd: item.devolution,
                  dosis: item.product_detail.dosis,
                  date: this.formatDate(item.dispatch_detail.date),
                  fecha_hora: det.fecha_hora,
                  stock_id: null,
                  incomen:det.incomen
                });
              });
            });
          });
        }
      },
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.$emit("mtdClose");
    },
    registrarDev() {
      Swal.fire({
        icon: "warning",
        title: "¿Está seguro de realizar la Devolución?",
        confirmButtonText: "Permitir",
        confirmButtonColor: "#3085d6",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        cancelButtonText: "Cerrar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.post({
            url:
              this.$store.getters.get__url + "/Pharmacy/returns/regdevdiarias",
            token: this.$store.getters.get__token,
            params: this.data,
          })
            .then((response) => {
              console.log(response);

              if (response.data.state == 0) {
                response.data.allNoteCreditIds.forEach((id) => {
                  window.open(
                    this.$store.getters.get__url +
                      "/viewpdfNoteCreditInt/" +
                      id,
                    "_blank"
                  );
                });
                this.$refs.SweetAlert.showSuccess(
                  "Devolucion Registrada Correctamente"
                );
                this.mtdClose();
              } else {
                this.$refs.SweetAlert.showError("Error");
              }
            })
            .catch((errors) => {
              console.log(errors);
              this.$refs.SweetAlert.showError(errors);
            });
        }
      });
    },
    mtdViewOtherLote(payload) {
      this.get({
        url:
          this.$store.getters.get__url +
          "/Pharmacy/returns/otherlotes/" +
          payload.product_detail_id +
          "/" +
          payload.lote,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          console.log(response);
          if (response.length > 0) {
            const stocks = response; // tu array
            const loteOptions = {};

            stocks.forEach((item) => {
              if (item.dispatch_detail && item.dispatch_detail.lote) {
                loteOptions[item.id] = `Lote: ${
                  item.dispatch_detail.lote
                } | Fec. Venc.: ${this.formatDate(
                  item.dispatch_detail.date
                )} | Cantidad: ${item.new_quantity}`;
              }
            });

            Swal.fire({
              title: "Seleccionar lote",
              input: "select",
              inputOptions: loteOptions,
              inputPlaceholder: "Seleccione un lote",
              showCancelButton: true,
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar",
              inputValidator: (value) => {
                if (!value) {
                  return "Debe seleccionar un lote";
                }
              },
            }).then((result) => {
              if (result.isConfirmed) {
                const selectedStock = stocks.find(
                    (item) => item.id == result.value
                );

                // el stock debe ser del mismo product_detail_id
                if (selectedStock.product_detail_id != payload.product_detail_id) {
                    return this.$refs.SweetAlert.showWarning(
                        "El lote seleccionado pertenece a otro producto. " +
                        "Por favor, selecciona un lote del mismo producto."
                    );
                }

                // verificar que tenga stock > 0
                if (parseInt(selectedStock.new_quantity) <= 0) {
                    return this.$refs.SweetAlert.showWarning(
                        "El lote seleccionado no tiene stock disponible."
                    );
                }
                // console.log("Seleccionado:", selectedStock);
                this.data.push({
                  type: 2,
                  patient_id: payload.patient_id,
                  serie: payload.serie,
                  dispatch_pharmacy_id: payload.dispatch_pharmacy_id,
                  molecule: payload.molecule,
                  presentation: payload.presentation,
                  lote: selectedStock.dispatch_detail.lote,
                  date: this.formatDate(selectedStock.dispatch_detail.date),
                  quantity: 0,
                  devolution: "",
                  product_detail_id: payload.product_detail_id,
                  dispatch_detail_id: selectedStock.dispatch_detail_id,
                  id: payload.id,
                  brand: payload.brand,
                  devolution_bd: 0,
                  dosis: payload.dosis,
                  stock_id: selectedStock.id,
                });
              }
            });
          } else {
            this.$refs.SweetAlert.showWarning(
              "No tiene más lotes"
            );
          }

          // Construimos las opciones del select
        })
        .catch((errors) => {
          console.log(errors);
          this.$refs.SweetAlert.showError(errors);
        });
    },
    formatDate(date) {
      if (!date) return "";

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
<style scoped>
#table-detalle {
  margin-top: 20px;
}

.table-responsive {
  overflow-x: auto;
}

.table-bordered {
  border: 1px solid #dee2e6;
}

.table th,
.table td {
  border: 1px solid #dee2e6;
  padding: 10px;
}

.bg-main {
  background-color: #900052 !important;
}

.text-white {
  color: #fff !important;
}

.text-muted {
  color: #6c757d !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.custom {
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  background-color: #900052;
  margin-bottom: 5px;
}

.btn-custom {
  background-color: #900052;
  font-weight: bold;
  font-size: 16px;
}

/*Linea de Separacion*/
.vertical-line {
  border-left: 1px solid #900052;
}

@media (max-width: 991px) {
  .vertical-line {
    border-left: none;
    border-top: 1px solid #900052;
  }
}

.guardar-btn {
  background-color: #ee7d8b;
  border-color: #ee7d8b;
  font-weight: bold;
  color: #fff;
}

.totals {
  border-radius: 2px;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  height: auto;
}
</style>

